import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { HIDE_DIALOG_DATA_TOKEN, HideDocumentDialogData } from './hide-document-dialog-data';
import { UploadedDocumentsStorage, VisibilityDocumentRequest } from './storages/uploaded-documents-storage';

@Component({
    selector: 'hide-document',
    template: require('./hide-document.component.html'),
    styles: [require('./hide-document.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HideDocumentComponent {
    public readonly editorForm: FormGroup;
    public readonly reasonControl = new FormControl(null);
    public readonly actionTitle: string;

    constructor(
        private readonly dialog: MdlDialogReference,
        private readonly dialogService: MdlDialogService,
        private readonly uploadedDocumentsStorage: UploadedDocumentsStorage,
        @Inject(HIDE_DIALOG_DATA_TOKEN) readonly dialogData: HideDocumentDialogData
    ) {
        this.editorForm = new FormGroup({
            'reason': this.reasonControl
        });
        this.actionTitle = this.dialogData.report.isHidden ? 'Unhide' : 'Hide';
    }

    public async onOk() {
        const confirmed = await this.showConfirm(`The document will be ${this.dialogData.report.isHidden ? 'unhidden' : 'hidden'}. Proceed?`);

        if (confirmed) {
            const request: VisibilityDocumentRequest = {
                documentId: this.dialogData.report.reportId,
                isHidden: !this.dialogData.report.isHidden,
                reason: this.reasonControl.value,
                reportId: null,
            };

            if (this.dialogData.report.category.isLabReport()) {
                request.reportId = this.dialogData.report.reportId;
                request.isHidden = !this.dialogData.report.isHidden;
                request.reason = this.reasonControl.value;
                request.documentId = '123';
            }

            try {
                this.editorForm.disable();

                await this.uploadedDocumentsStorage.changeVisibility(this.dialogData.report.category, request);
                await this.uploadedDocumentsStorage.forceLoadDocuments();

                this.dialog.hide();
            } catch (e) {
                this.editorForm.enable();
                throw e;
            }
        }
    }

    public onCancel() {
        this.dialog.hide();
    }

    protected async showConfirm(confirmationText: string): Promise<boolean> {
        try {
            await this.dialogService.confirm(confirmationText, 'No', 'Yes').toPromise();
            return true;
        } catch {
            return false;
        }
    }
}
